import type { ProductStepProps, StepKeys } from "../../steps/types";
import type { WorkflowProduct } from "./ProductWorkflowConfiguration";

export abstract class WorkflowStep<TStepKey extends StepKeys> {
  abstract readonly key: TStepKey;
  abstract readonly label: string;
  readonly optional?: boolean;
  abstract readonly Component: React.ComponentType<ProductStepProps>;
  readonly props?: Record<string, unknown>;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public isSkipped = (_product: WorkflowProduct) => false;

  constructor({
    isSkipped,
  }: { isSkipped?: (product: WorkflowProduct) => boolean } = {}) {
    if (isSkipped) {
      this.isSkipped = isSkipped;
    }
  }
}
